import React from 'react';
import PropTypes from 'prop-types';
// import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import gaPush from '../../../globs/utils/google-analytics';
// import FormattedNumberCustom from '../../../../app/components/formatted-number-custom';

const fireGaEvent = (act, action, labelIn) => {
  const label = `${labelIn}`;
  gaPush('event', {
    category: act,
    action,
    label,
  });
};


function complaintListItem(props) {
  const gaEvents = () => {
    console.log('detailArray', props);
    // fireGaEvent('Contact Us', 'Complaint Detail',
    //  `Type: ${props.complaint.comp_type},
    //  Status: ${props.complaint.complaint_status},
    //  Rating: ${props.complaint.rating ? props.complaint.rating : 'N/A'},
    //  Feedback: ${props.complaint.feedback ? 'Y' : 'N'} ${props.complaint.rating ? '' : 'N/A'}
    //  `);
    fireGaEvent('ContactUs', 'RecordClicked', `${props.complaint.complaint_number}`);
    fireGaEvent('ContactUs', 'RecordClicked', `${props.complaint.complaint_status}`);
    // const detailArray = this.props.complaints.find(item => item.id === this.props.complaint.id);
    // console.log('detailArray', detailArray);
  };
  let showCategory = '';
  if (props.complaint.complaint_sub_category) {
    // showCategory = <span> {props.complaint.complaint_category}
    // <i className="icon-arrow_right" /> {props.complaint.complaint_sub_category} </span>;
    showCategory = <span> {props.complaint.complaint_category } <i className="icon-arrow_right" /> {props.complaint.complaint_sub_category} </span>;
  } else if (props.complaint.complaint_category) {
    // showCategory = props.complaint.complaint_category;
    showCategory =props.complaint.complaint_category;
  }
  return (
    <div key={props.complaint.id}>
      <div className={`complaint-list-item ${props.complaint.is_update ? 'complaint-update' : ''}`} onClick={() => { props.push(`/complaint-detail/${props.customerId}/${props.complaint.id}`); gaEvents(); }}>
        <span className="complaint-list-item-label">{showCategory}</span>
        <i className="icon-arrow_left" />
        {
          props.complaint.reference_number &&
          <div className="reference-number">
            <span className="reference-number-label">Reference: </span>
            <span className="reference-number-value">{props.complaint.reference_number}</span>
          </div>
        }
        <div className="complaint-date-id">
          <span className="list-item-date-id">
            <div className="complaint-number">
              {props.complaint.complaint_number}
            </div>
            <div className="complaint-date-time">{moment(props.complaint.created_at).format('DD.MM.YYYY | HH:mm')}</div>
          </span>
          <button style={{ background: `${props.complaint.status_color ? props.complaint.status_color : ''}` }} className={`${(props.complaint.complaint_status).toLowerCase()}-button`}>
            {/* <FormattedMessage id={`Status.${props.complaint.complaint_status}`} /> */}
            <span>{props.complaint.complaint_status}</span>
            </button>
        </div>
        <div className="complaint-info-short"><p>{props.complaint.description}</p></div>
        <div className="attachment-comment">
          <span>
            {/* <FormattedMessage id="Attachments.text" /> */}
           <span>Attachments</span>({props.complaint.complaint_files_count})</span>
          {props.complaint.comment &&
            <span>
              <span>Comment</span>(01)
              {/* <FormattedMessage id="DigitalOrdering.Comment" /> */}
            {/* (<FormattedNumberCustom value="01" />) */}
            </span>
          }
        </div>
      </div>
    </div>
  );
}

complaintListItem.propTypes = {
  complaint: PropTypes.shape({
    complaint_sub_category: PropTypes.string,
    reference_number: PropTypes.string,
    complaint_category: PropTypes.string,
    complaint_number: PropTypes.string,
    created_at: PropTypes.string,
    complaint_status: PropTypes.string,
    is_update: PropTypes.bool,
    description: PropTypes.string,
    comment: PropTypes.string,
    comp_type: PropTypes.string,
    rating: PropTypes.number,
    feedback: PropTypes.string,
    id: PropTypes.number,
    complaint_files_count: PropTypes.number,
    status_color: PropTypes.string,
  }).isRequired,
  customerId: PropTypes.string,
  // intl: PropTypes.shape({
  //   formatMessage: PropTypes.shape({}),
  // }).isRequired,
  push: PropTypes.func.isRequired,
  showDetailComplaint: PropTypes.func.isRequired,
};

export default complaintListItem;
